import { useToken } from "@gluestack-style/react";
import CallToAction from "components/general/CallToAction";
import ScrollContainer from "components/general/ScrollContainer";
import Seo from "components/general/Seo";
import { PageRender } from "components/page/PageRender";
import React from "react";
import { Page } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";

export default function PageDetail({ page }: { page: Page }) {
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const isMobile = useIsMobile();

	const defaultTextProps = {
		selectable: true,
	};
	return (
		<ScrollContainer>
			<Seo title={page.metaTitle} description={page.metaDescription} />
			{/* <Box bg="$neutral25"> */}
			{/* <Container> */}
			<PageRender content={page.content} />
			{/* </Container> */}
			{/* </Box> */}
			{page?.callToAction && <CallToAction type={page.callToAction as "Contact Us" | "Download Brochure" | "Request a Quote" | "Book a Meeting"} />}
		</ScrollContainer>
	);
}
